export default "__VITE_ASSET__4Pr0EFSX__"